import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import Button from "./button"

export default function Homemap() {
  return (
    <div className="relative flex flex-col md:flex-row w-full justify-center mx-auto bg-pfb-blue py-[60px] overflow-hidden">
      {/* Semi-transparent overlay */}
      <div className="absolute inset-0 z-0">
        <StaticImage
          src="../images/hp-map-bg.png"
          alt=""
          placeholder="blurred"
          layout="fullWidth"
          className="w-full h-full object-cover opacity-30 filter saturate-150"
        />
      </div>

      {/* Content container */}
      <div className="relative z-10 flex flex-col md:flex-row w-full justify-center items-center">
        {/* Map container */}
        <div className="flex md:w-2/3 aspect-video justify-center items-center md:max-w-[500px] px-3 sm:px-6 lg:px-2">
          <StaticImage
            src="../images/hp-map.png"
            alt="Image of the United States"
            placeholder="blurred"
            layout="constrained"
          />
        </div>

        {/* Text container */}
        <div className="w-full md:w-1/3 flex flex-col justify-center p-8 md:text-left text-center">
          <h2 className="font-dharma font-bold text-5xl lg:text-6xl mb-4 lg:mb-6 text-white">
            Support projects in your backyard
          </h2>
          <div className="mb-4">
            <Button
              link={"/map"}
              text="Explore the map"
              type="small"
              color="navy"
            />
          </div>
          <Button
            link={"/project-list"}
            text="Explore projects"
            type="small"
            color="navy"
          />
        </div>
      </div>
    </div>
  )
}
